import React from "react";

import Map from "./map";
import LivePositions from "./LivePositions";
import Routes from "./Routes";
import Speedometer from "./Speedometer";

const Index = () => {
    return (
        <Map>
            <LivePositions />
            <Routes />
            <Speedometer />
        </Map>
    );
};

export default Index;
